import { RegisterDateType } from '../types';
import { useMemo } from 'react';
import { calculateRegister } from '../utils/function';

type FooterSummaryProps = {
  data: RegisterDateType[];
  dateFrom: string;
};

export const FooterSummary = (props: FooterSummaryProps) => {

  const calculate = useMemo(
    () => calculateRegister(props.data),
    [props.data],
  );

  return (
    <table className="w-auto min-w-[50px] md:max-w-[400px]">
      <tbody className="text-md">
        <tr className="text-right">
          <td className="w-[1px] whitespace-nowrap pr-3  uppercase font-bold">Summary Qty Order :</td>
          <td className="font-bold">{calculate.qty_order.toLocaleString()}</td>
        </tr>
        <tr className="text-right">
          <td className="w-[1px] whitespace-nowrap pr-3  uppercase font-bold">Summary Qty Shipped :</td>
          <td className="font-bold">{calculate.qty_delivered.toLocaleString()}</td>
        </tr>
        <tr className="text-right">
          <td className="w-[1px] whitespace-nowrap pr-3  uppercase font-bold">Summary Payment :</td>
          <td className="font-bold">{calculate.payment.toLocaleString()}</td>
        </tr>
        <tr className="text-right">
          <td className="w-[1px] pt-2 whitespace-nowrap pr-3 uppercase font-bold">Summary Balance :</td>
          <td className="pt-2 font-bold">{(Number(calculate.total) - Number(calculate.payment)).toLocaleString()}</td>
        </tr>
      </tbody>
    </table>
  );
};
